import React, { Component } from 'react';
import ReactPlayer from 'react-player';

import Button from '../button/button';

import OffsetVideo from '../../../applications/dialogs/addvideo/offsetvideo';

import playbutton from "./assets/play-button.png";
import stopbutton from "./assets/stop-button.png";
import nextbutton from "./assets/next-button.png";
import prevbutton from "./assets/prev-button.png";

import takeinbutton from "./assets/takein.png"
import takeoutbutton from "./assets/takeout.png"

import channel1button from "./assets/audio1.png";
import channel2button from "./assets/audio2.png";


import channel1onbutton from "./assets/audio1on.png";
import channel2onbutton from "./assets/audio2on.png";


import mutebuttonon from "./assets/muteon.png";
import mutebuttonoff from "./assets/muteoff.png";
import setoffsetbutton from "./assets/setoffset.png";


import { V2_RoundedTimeCode, V2_GetSecondTimeCodeStart,V2_GetSecondTimeCodeStartMS, V2_GetOneFrameDuration, V2_ConvertSecondToTimeCodeString,V2_ConvertSecondToTimeCodeStringMs } from '../../../utils/timecodev2';
import { keyboard_multi_getKey } from '../../../utils/keyboard_multi';


import { getAssetColorsByType } from '../../../utils/colors';

import "./videoplayer.css";



class VideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.playerRef = React.createRef();  // Référence au lecteur ReactPlayer
    this.canvasLevel1Ref = React.createRef();  // Référence au canvas
    this.canvasLevel2Ref = React.createRef();  // Référence au canvas layer 2 time code
    this.canvasLevel3Ref = React.createRef();  // Référence au canvas layer 3 sous titre
    this.sliderVideoRef = React.createRef(); // video slider
    this.sliderVolumeRef = React.createRef(); // slider volume


    this.state = { isPlaying: false,
                   isReady:false,
                   videoPosition:0,
                   videoVolume:100,
                   mute: false,
                   channel: 1,
                   lastCurrentTime: -1,
                   modeA: true,
                   modeB: false,
                   modeC: false,
                   displaysetoffset: false,
                   videostartx: 0,
                   videostarty: 0,
                   videowidthx: 0,
                   videoheighty:0
                   

    };

    

    this.mode = "none";

    this.videoElement = null;  // Élément vidéo natif

    this.handleReady = this.handleReady.bind(this);
    this.handlePlay = this.handlePlay.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleWheel = this.handleWheel.bind(this);
    this.addtime = this.addtime.bind(this);
    this.handleSliderVideo = this.handleSliderVideo.bind(this);
    this.handleSliderVolume = this.handleSliderVolume.bind(this);
    this.handleOnTimeUpdate = this.handleOnTimeUpdate.bind(this);
    this.isResising=false;
    this.takein = this.takein.bind(this);
    this.takeout = this.takeout.bind(this);

    this.play = this.play.bind(this);
    this.previous = this.previous.bind(this);
    this.next = this.next.bind(this);

    this.mute = this.mute.bind(this)
    this.channel1 = this.channel1.bind(this)
    this.channel2 = this.channel2.bind(this)
    this.setoffset = this.setoffset.bind(this)
    this.endSetOffset = this.endSetOffset.bind(this)

    var style = getComputedStyle(document.body)
    this.buttonheight = style.getPropertyValue('--player-buttons-height');

    // timer video
    this.timerVideo = null;

  }



  componentDidMount() {

    const scrolldiv = document.getElementById("videoplayerFullDiv");
    if (scrolldiv ) scrolldiv.addEventListener("wheel", this.handleWheel);

    this.timerVideo = setInterval(() => {
      if (this.videoElement) {

        var currenttime = this.videoElement.currentTime;


        if (currenttime != this.state.lastCurrentTime) {
          if (this.state.modeA || this.state.isPlaying) {
            if (this.props.onNewTime) this.props.onNewTime(currenttime);           
          }
          
           this.setState({ lastCurrentTime: currenttime });
           if (!this.videoElement.videoWidth)
             this.drawVideoToCanvas()
        } 

      }
    }, 80);

    const div = document.querySelector('#canvasPlayer'); // Sélectionne la div
    if (div)
    {
      // Crée un ResizeObserver
      this.resizeObserver = new ResizeObserver(entries => {
        //this.resizeObserver.disconnect();
        for (let entry of entries) {

          //this.resizeObserver.disconnect();
          this.reDrawCurrentFrame();
          //this.resizeObserver.observe(document.querySelector('#canvasPlayer'));
        }
      });
      
      // Observer les changements de taille de la div time line
      // $$$ ICI
      this.resizeObserver.observe(div);
    }

  }

  componentWillUnmount() {
    clearInterval(this.timerVideo);
    const scrolldiv = document.getElementById("videoplayerFullDiv");
    if (scrolldiv) scrolldiv.removeEventListener("wheel", this.handleWheel);
    
  }

  handleWheel = (event) =>
  {
    event.preventDefault();
    
    if (event.deltaY >0)
      this.addtime (this.GetFrameDuration() );
    else
    this.addtime (-this.GetFrameDuration() );
  }


    async resizeCanvasToBase64(canvas, newWidth, newHeight, quality = 0.9) {
    // Crée un nouveau canvas temporaire
    const resizedCanvas = document.createElement("canvas");
    resizedCanvas.width = newWidth;
    resizedCanvas.height = newHeight;

    const ctx2 = resizedCanvas.getContext("2d");
    ctx2.drawImage(canvas, 0, 0, newWidth, newHeight);

    // Attendre la création du Blob JPEG
    const blob = await new Promise(resolve =>
      resizedCanvas.toBlob(resolve, "image/jpeg", quality)
    );

    // Convertir le blob en Base64
    const base64 = await new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // DataURL (base64)
      reader.readAsDataURL(blob);
    });

    return base64; // ex: "data:image/jpeg;base64,/9j/4AAQSkZJRgABA..."
  }

  getPredefinedValue()
  {
      
      var useconfintervalvalue = false;
      var playerintervalvalue = 20;

      if (this.props.params)
      {
        if ("useconfintervalvalue" in this.props.params) useconfintervalvalue=this.props.params.useconfintervalvalue;
        if ("playerintervalvalue" in this.props.params) playerintervalvalue=this.props.params.playerintervalvalue;
      }
      var value = playerintervalvalue;
      if (useconfintervalvalue)
      {
        if (this.props.stparams)
        {
          value = this.props.stparams.i_interst;
        }
      }
      return value * this.GetFrameDuration();
  }
  keyboard_multi_gereKeyBoard(shortcuts, code, shift, ctrl, alt) 
  {
    const key = keyboard_multi_getKey("player", shortcuts, code, shift, ctrl, alt);

    if (key !== "") {
      if (this.videoElement) {
        switch (key) {
          case "PLAY": this.play(); break;
          case "STOP": this.pause(); break;
          case "NEXTF": this.addtime(this.GetFrameDuration()); break;
          case "PREVF": this.subtime(this.GetFrameDuration()); break;
          case "NEXT20": this.addtime(this.getPredefinedValue()); break;
          case "PREV20": this.subtime(this.getPredefinedValue()); break;
          case "NEXT1": this.addtime(1); break;
          case "PREV1": this.subtime(1); break;
          case "TIMELINEMODE":
            if (this.props.onTimelineMode) this.props.onTimelineMode();
            break;
          case "ADDCP":
            (async () => {
              this.videoElement = this.getInternalPlayer();

              if (!this.state.isPlaying && this.videoElement) {
                const canvas = this.canvasLevel1Ref.current;
                const base64 = await this.resizeCanvasToBase64(canvas, 96, 60, 0.8);
                const timecode = this.playerRef.current.getCurrentTime();

                if (this.props.onAddCP) this.props.onAddCP(base64, timecode);
              }
            })();
            break;
          case "PLAYERPREVIOUSCP":
          case "PLAYERNEXTCP":
            if (this.props.stparams)
            {
              if ("cplist" in this.props.stparams)
              {
                var tc = this.playerRef.current.getCurrentTime();
                var newtc = -1;
                switch (key)
                {
                  case "PLAYERNEXTCP":
                   
                    for (var cp=0; cp<this.props.stparams.cplist.length && newtc === -1 ; cp++)
                      if (this.props.stparams.cplist[cp].time > tc)
                        newtc = this.props.stparams.cplist[cp].time;
                    break;
                  case "PLAYERPREVIOUSCP":
                    
                    for (var cp=this.props.stparams.cplist.length-1; cp>=0 && newtc === -1 ; cp--)
                      if (this.props.stparams.cplist[cp].time < tc)
                        newtc = this.props.stparams.cplist[cp].time;
                    break;
                }
              

                if ((newtc !== -1) && (this.playerRef.current) && (this.playerRef.current))
                {
                    if (this.videoElement)
                    {
                      this.pause();
                      this.videoElement.currentTime = newtc ;
                    }
                }
              }


            }
            break;
        }
      }
      return true;
    }
    return false;
  }

 
  handleSliderVolume(event)
  {


    
    this.setState( {videoVolume : event.target.value, mute: event.target.value == 0})


    if ((this.playerRef) && (this.playerRef.current) && (this.videoElement))
    {
        this.videoElement.volume = event.target.value / 100;
        this.videoElement.muted = event.target.value == 0;
        
    }

  }

  endSetOffset(button, datas)
  {
    
    this.setState({displaysetoffset:false});
    if ((this.props.video) && (button == "ok"))
    {
      this.props.video.vitimecode = datas.reeloffset;
      this.props.video.vidropframe = datas.dropframe;
      this.videoElement.currentTime = this.videoElement.currentTime;
      if (this.props.onNewTime) this.props.onNewTime(this.videoElement.currentTime, true);
      if (this.props.onMustReload) this.props.onMustReload(button,datas);
    }
    

  }
  setoffset()
  {

      this.setState({displaysetoffset:true});
  }
  mute()
  {
     const newmute = !this.state.mute;
     this.setState({mute: newmute});

     if ((this.playerRef) && (this.playerRef.current) && (this.videoElement))
    {
      this.videoElement.muted = newmute;
      
    }

  }

  selectAudioTrack (index)
  {
    
    if (this.videoElement.audioTracks && this.videoElement.audioTracks.length > 0) 
      {
      // Disable all audio tracks
      for (let i = 0; i < this.videoElement.audioTracks.length; i++) {
        this.videoElement.audioTracks[i].enabled = false;
      }
      // Enable the selected audio track
      if (index >= 0 && index < this.videoElement.audioTracks.length) {
        this.videoElement.audioTracks[index].enabled = true;
      }
    } 
  }

  channel1()
  {
    
    this.selectAudioTrack(0)
      this.setState({channel: 1});
      if ((this.props.onchangechannel) && (this.props.video))
        this.props.onchangechannel(1, this.props.video)
  }

  channel2()
  {
    this.selectAudioTrack(1)
    this.setState({channel: 2});
      if ((this.props.onchangechannel) && (this.props.video))
        this.props.onchangechannel(1, this.props.video)
}

  handleSliderVideo(event)
  {
    const manualChange = Number(event.target.value);
    this.pause();
    this.videoElement.currentTime = (this.videoElement.duration / 100) * manualChange;
    
   
    this.setState( {videoPosition : manualChange})
  }


  handleOnTimeUpdate (event)
    {
        if (this.videoElement  )
        {
          
          var currenttime = this.videoElement.currentTime;
          
          var duration = this.videoElement.duration;
          if (duration)
          {
            const progress = (currenttime / duration) * 100;
            this.setState( {videoPosition : progress})
       
            
          }
          
        }
    };  

  drawTimeCode =(timecode) =>
  {

    
    const canvas = this.canvasLevel2Ref.current;
    
    const context = canvas.getContext('2d');


    
    canvas.width = 720; canvas.height = 576;
    context.clearRect(0, 0, canvas.width, canvas.height);



    
    

    this.drawVideoID(context,6,6);

    if (!this.props.params.displaytc) return;

    context.textAlign = "left";
    context.textBaseline = "alphabetic";




    context.font = "30px courier new";
    context.fillStyle="White";
    context.strokeStyle="black";
    context.lineWidth=4;
    var stimecode = "";

    timecode = V2_RoundedTimeCode(timecode,this.props.video.vinum, this.props.video.viden);
    stimecode = this.GetLocalTimeCode(timecode);
    
    
    

    context.strokeText(stimecode,30,30);
    context.fillText(stimecode,30,30);

    const nx = context.measureText(stimecode).width;

    context.font = "12px Arial";
    context.fillStyle="White";
    context.strokeStyle="black";
    context.lineWidth=2;
    const ti = this.formatTime(timecode)
    context.strokeText(ti,30 + nx + 5,30);
    context.fillText(ti,30 + nx + 5,30);

  }

formatTime(totalSeconds) {
  totalSeconds = Math.floor(totalSeconds);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');

  if (hours === 0) {
    return `${mm}:${ss}`; // mm:ss
  }

  const hh = String(hours).padStart(2, '0');
  return `${hh}:${mm}:${ss}`; // hh:mm:ss
}



  GetFrameDuration()
  {
    if (this.props.video) return V2_GetOneFrameDuration(this.props.video.vinum, this.props.video.viden);
  }

  GetInternalTimeCodeSecond(timecode)
  {
    if (this.props.video)
    {
      if (this.props.params.displaytcms)
      {
          const secstart = V2_GetSecondTimeCodeStartMS(this.props.video.vitimecode,this.props.video.vinum,this.props.video.viden);
          timecode = timecode - secstart;
          if (timecode < 0) timecode  = 0;
      }
      else
      {
          const secstart = V2_GetSecondTimeCodeStart(this.props.video.vitimecode,this.props.video.vinum,this.props.video.viden)
          timecode = timecode - secstart;
          if (timecode < 0) timecode  = 0;
      }
      timecode = V2_RoundedTimeCode(timecode ,this.props.video.vinum, this.props.video.viden);
    }

    
    return timecode;

  }

  getTimeCode()
  {

    return this.GetLocalTimeCodeSecond(this.getCurrentPlayerTime());
  }

  GetLocalTimeCodeSecond(timecode)

  {

    if (this.props.video)
    {
      if (this.props.params.displaytcms)
      {
          const secstart = V2_GetSecondTimeCodeStartMS(this.props.video.vitimecode,this.props.video.vinum,this.props.video.viden);


          return V2_RoundedTimeCode(timecode + secstart,this.props.video.vinum, this.props.video.viden);


      }
      else
      {
          const secstart = V2_GetSecondTimeCodeStart(this.props.video.vitimecode,this.props.video.vinum,this.props.video.viden)
          return V2_RoundedTimeCode(timecode + secstart,this.props.video.vinum, this.props.video.viden);
      }
    }
    else
      return timecode;
  }

  GetLocalTimeCode(timecode)
  {
    
    if (this.props.video)
    {



        
        if (this.props.params.displaytcms)
        {
          var secstart = V2_GetSecondTimeCodeStartMS(this.props.video.vitimecode,this.props.video.vinum,this.props.video.viden)

          secstart = V2_RoundedTimeCode(timecode + secstart,this.props.video.vinum,this.props.video.viden)
          return V2_ConvertSecondToTimeCodeStringMs(secstart,
            this.props.video.vinum,
            this.props.video.viden,
            this.props.video.vidropframe,
            this.props.video.vitimecode
          );
        }
        else
        {
          var secstart = V2_GetSecondTimeCodeStart(this.props.video.vitimecode,this.props.video.vinum,this.props.video.viden)
          secstart = V2_RoundedTimeCode(timecode + secstart,this.props.video.vinum,this.props.video.viden)
          return V2_ConvertSecondToTimeCodeString(secstart,
            this.props.video.vinum,
            this.props.video.viden,
            this.props.video.vidropframe,
            this.props.video.vitimecode
          );
        }
        
    }
    else
    {

        //var secstart = V2_GetSecondTimeCodeStart(this.props.video.vitimecode,this.props.video.vinum,this.props.video.viden)
        //secstart = V2_RoundedTimeCode(secstart,this.props.video.vinum,this.props.video.viden)
        if (this.props.params.displaytcms)
          return V2_ConvertSecondToTimeCodeStringMs(timecode);
        else
          return V2_ConvertSecondToTimeCodeString(timecode);
    }
  }
  getInternalPlayer()
  {
    if ((this.playerRef) && (this.playerRef.current))
      return this.playerRef.current.getInternalPlayer();
    return null;
  }


  
  // Méthode pour dessiner la vidéo sur le canvas
  drawVideoToCanvas = () => {
    const canvas = this.canvasLevel1Ref.current;
    const context = canvas.getContext('2d');

    const drawFrame = () => {
      this.videoElement = this.getInternalPlayer()
      
      if (this.state.isPlaying && this.videoElement) 
        {
        // Vérifier que la vidéo est prête
        var vidwidth = 720;
        var vidheight = 576;
        var novideo= true;
        if (this.videoElement.videoWidth > 0 && this.videoElement.videoHeight > 0) {
          // Définir la taille du canvas en fonction de la vidéo

          
          var vidwidth = this.videoElement.videoWidth;
          var vidheight = this.videoElement.videoHeight;

          novideo=false;
        }
          

          if (this.props.params.dontscale)
            {
              const videodiv = document.getElementById("videoplayerFullDiv");
              const rect = videodiv.getBoundingClientRect();
              const divwidth = (rect.right - rect.left);
              const divheight = (rect.bottom - rect.top);
      
      
      
              const ratiodiv = divwidth/divheight;
              const ratiovid = vidwidth/vidheight
              
              if ( ratiodiv > ratiovid)
              {
                  // ici on garde la hauteur de la video
                  // et on prend la largeur de la div
      
                  canvas.height = vidheight;
                  canvas.width = vidheight * divwidth/divheight;
      
                  
      
                  const videostartx = (canvas.width - vidwidth)/2;;
                  const videowidthx = vidwidth;
                  const videostarty = 0;
                  const videoheighty = vidheight;
      
                  this.setState({videostartx, videowidthx,videostarty, videoheighty});
      
                  if (!novideo) context.drawImage(this.videoElement, 0, 0, vidwidth, vidheight,videostartx,videostarty,vidwidth, vidheight);
      
      
      
              }
              else
              {
                  // ici on garde la largeur de la video
                  // et on prend la recalcule la hauteur
      
                  canvas.width = vidwidth;
                  canvas.height = vidwidth * divheight/divwidth;
      
                  
      
                  const videostartx = 0;
                  const videowidthx = vidwidth;
                  const videostarty = (canvas.height - vidheight)/2;
                  const videoheighty = vidheight;
      
                  this.setState({videostartx, videowidthx,videostarty, videoheighty});
      
                  if (!novideo) context.drawImage(this.videoElement, 0, 0, vidwidth, vidheight,videostartx,videostarty,vidwidth, vidheight);
      
      
      
      
              }
            }
            else
            {
      
                const videostartx = 0;
                const videowidthx = vidwidth;
                const videostarty = 0;
                const videoheighty = vidheight;
                canvas.width = this.videoElement.videoWidth;
                canvas.height = this.videoElement.videoHeight;
                this.setState({videostartx, videowidthx,videostarty, videoheighty});

                if (!novideo) context.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height);
            }
      
      
      

          
          if (this.playerRef.current) 
          {
            const timecode  = this.playerRef.current.getCurrentTime();
            
            this.drawTimeCode (timecode);
            this.childDrawVideoToCanvas(timecode); // function PURE
          }

        }

        // Continuer à dessiner le prochain frame
        
        if (!novideo) requestAnimationFrame(drawFrame);
      }
    

    // Lancer la boucle de dessin
    drawFrame();
  };

  
  getCurrentPlayerTime()
  {
    var tc = 0;
    if (this.playerRef.current) tc = this.playerRef.current.getCurrentTime();

    return Math.round(tc * 100) / 100;;
  }

  reDrawCurrentFrame()
  {
    if (!this.playerRef) return;
    if (!this.playerRef.current) return;

    // Accéder à l'élément vidéo natif
    this.videoElement = this.getInternalPlayer();
    if (!this.videoElement) return;


    

    if (this.videoElement.videoWidth > 0 && this.videoElement.videoHeight > 0) 
      {
      // Définir la taille du canvas en fonction de la vidéo
      const canvas = this.canvasLevel1Ref.current;
      const context = canvas.getContext('2d');
      const vidwidth = this.videoElement.videoWidth;
      const vidheight = this.videoElement.videoHeight;

      if (this.props.params.dontscale)
      {
        const videodiv = document.getElementById("videoplayerFullDiv");
        const rect = videodiv.getBoundingClientRect();
        const divwidth = (rect.right - rect.left);
        const divheight = (rect.bottom - rect.top);



        const ratiodiv = divwidth/divheight;
        const ratiovid = vidwidth/vidheight
        
        if ( ratiodiv > ratiovid)
        {
            // ici on garde la hauteur de la video
            // et on prend la largeur de la div

            canvas.height = vidheight;
            canvas.width = vidheight * divwidth/divheight;

            

            const videostartx = (canvas.width - vidwidth)/2;;
            const videowidthx = vidwidth;
            const videostarty = 0;
            const videoheighty = vidheight;

            this.setState({videostartx, videowidthx,videostarty, videoheighty});

            context.drawImage(this.videoElement, 0, 0, vidwidth, vidheight,videostartx,videostarty,vidwidth, vidheight);
        }
        else
        {
            // ici on garde la largeur de la video
            // et on prend la recalcule la hauteur

            canvas.width = vidwidth;
            canvas.height = vidwidth * divheight/divwidth;
            const videostartx = 0;
            const videowidthx = vidwidth;
            const videostarty = (canvas.height - vidheight)/2;
            const videoheighty = vidheight;

            this.setState({videostartx, videowidthx,videostarty, videoheighty});

            context.drawImage(this.videoElement, 0, 0, vidwidth, vidheight,videostartx,videostarty,vidwidth, vidheight);
        }
      }
      else
      {

        const videostartx = 0;
        const videowidthx = vidwidth;
        const videostarty = 0;
        const videoheighty = vidheight;

        this.setState({videostartx, videowidthx,videostarty, videoheighty});


          canvas.width = this.videoElement.videoWidth;
          canvas.height = this.videoElement.videoHeight;
          context.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height);
      }



      }
      if (this.playerRef.current) 
      {
        const timecode = this.getCurrentPlayerTime();
        this.drawTimeCode (timecode);
        this.childRedrawCurrentFrame(timecode); // Pure function
      }

  }


  // Gestion de l'événement lorsque la vidéo est prête
  handleReady = () => {

    if (!this.playerRef) return;
    if (!this.playerRef.current) return;

    // Accéder à l'élément vidéo natif
    this.videoElement = this.getInternalPlayer();
    if (!this.videoElement) return;
   
    this.videoElement.addEventListener('timeupdate', this.handleOnTimeUpdate);
    /*
    console.log("Élément vidéo :", this.videoElement);
    console.log("Pistes audio :", this.videoElement.audioTracks);

    if (this.videoElement.audioTracks) {
        console.log("Nombre de pistes :", this.videoElement.audioTracks.length);
    }
    */
    this.reDrawCurrentFrame();
 
    if (this.props.onready) this.props.onready (this.videoElement.duration);

    this.setState({isReady:true, isPlaying:false});

    
    
  };

  // Gérer la lecture de la vidéo
  handlePlay = () => {

    
    

    this.drawVideoToCanvas();  // Commencer à dessiner sur le canvas
  };

  // Gérer la pause de la vidéo
  handlePause = () => {
    this.setState( {isPlaying:false});
  };

  gotoStart()
  {
    if ((this.playerRef) && (this.playerRef.current) && (this.videoElement))
    {
        this.pause();
        this.videoElement.currentTime = 0;
    }

  }
  gotoEnd()
  {
    if ((this.playerRef) && (this.playerRef.current) && (this.videoElement))
    {
        this.pause();
        this.videoElement.currentTime = this.videoElement.duration;
    }

  }

  addtime (timesecond)
  {
    if ((this.playerRef) && (this.playerRef.current) && (this.videoElement))
    {
        this.pause();


        var currenttime = V2_RoundedTimeCode(this.videoElement.currentTime, this.props.video.vinum, this.props.video.viden);
        currenttime += timesecond;

        currenttime = V2_RoundedTimeCode(currenttime, this.props.video.vinum, this.props.video.viden);
        if (currenttime <= this.videoElement.duration)
            this.videoElement.currentTime = currenttime + .005;
      }

  }

  subtime (timesecond)
  {
    if ((this.playerRef.current) && (this.videoElement))
    {
        this.pause();
        var currenttime = V2_RoundedTimeCode(this.videoElement.currentTime, this.props.video.vinum, this.props.video.viden);
        currenttime -= timesecond;
        if (currenttime < 0) currenttime=0;
        currenttime = V2_RoundedTimeCode(currenttime, this.props.video.vinum, this.props.video.viden);
        this.videoElement.currentTime = currenttime + 0.005;
      }
  
  }
  

takein()
{
  this.gotoStart(); return;
  this.props.ondetectionButton({button:"takein", value:this.videoElement.currentTime})
}

takeout()
{
  this.gotoEnd(); return;
  this.props.ondetectionButton({button:"takeout", value:this.videoElement.currentTime})
}


goto (timesecond)
{
  timesecond = this.GetInternalTimeCodeSecond(timesecond);
  if ((this.playerRef.current) && (this.playerRef.current))
  {
      if (this.videoElement)
      {
        this.pause();
        this.videoElement.currentTime = timesecond ;
      }
  }
}

 previous()
 {
    if ((this.playerRef) && (this.playerRef.current))
        this.subtime(this.GetFrameDuration());
 }

 next()
 {
    if (this.playerRef.current)
        this.addtime(this.GetFrameDuration());
  
 }

pause()
{
  if (this.playerRef.current)
  {
      
      this.setState( {isPlaying:false});
      if (this.videoElement) this.videoElement.pause();
  }

}

 play()
  {
    if (this.playerRef.current)
    {
        this.videoElement = this.getInternalPlayer();
        if (this.state.isPlaying)
        {
          this.setState( {isPlaying:false});
          if (this.videoElement) this.videoElement.pause();
        }
        else
        {
          this.setState( {isPlaying:true});
          
          if (this.videoElement)  this.videoElement.play();
        }
    }
  }


  drawRoundedRect(ctx, x, y, width, height, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.arcTo(x + width, y, x + width, y + radius, radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
    ctx.lineTo(x + radius, y + height);
    ctx.arcTo(x, y + height, x, y + height - radius, radius);
    ctx.lineTo(x, y + radius);
    ctx.arcTo(x, y, x + radius, y, radius);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
}


drawVideoID(ctx, x, y ) 
{

      if (!this.props.video) return;
      // Dimensions et styles
      const  radius = 3;

      const text = this.props.video.viid;


      const colors = getAssetColorsByType("video")
      ctx.fillStyle = colors.backcolor; // Couleur de fond
      ctx.strokeStyle = colors.backcolor; // Couleur du contour
      ctx.lineWidth = 1;
  
      ctx.font = "12px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const width = ctx.measureText(text).width+ 6;
      const height = 14;


      // Dessiner le rectangle arrondi
      this.drawRoundedRect(ctx, x, y, width, height, radius);

      // Dessiner le texte
      ctx.fillStyle = colors.color; // Couleur du texte


      // Positionner le texte au centre du rectangle
      ctx.fillText(text, x + width / 2, y + height / 2);



}

getExtraRender()
{
  return (<></>)
}


// Exécuter le dessin lorsque la page est chargée

  render() 
  {

    var disableplayer = !this.state.isReady;

    //url="https://neweasysubdatas.easydirect.fr/videos/BR0217LN_EasySub.mp4"  

    var videofile = ""
    if (this.props.src !== null)
      videofile = this.props.src;

    var channel2enable = this.state.isReady;
    if (this.props.video !== null)
        if (this.props.video.vinbaudio < 2)
          channel2enable = false;

    const extra = this.getExtraRender();

    var extrabuttons = [];
    if (this.props.ondetectionButton)
    {

        extrabuttons.push (<>
                <Button disable={!this.state.isReady} image={takeinbutton} width={this.buttonheight} height={this.buttonheight} onClick={this.takein}/>
                <Button disable={!this.state.isReady} image={takeoutbutton} width={this.buttonheight} height={this.buttonheight} onClick={this.takeout}/>
                </>

        )

    }

    
    var offsetdialog = (<></>)
    if (this.state.displaysetoffset)
      offsetdialog = (
      <OffsetVideo display = {this.state.displaysetoffset} 
            viid = {this.props.video.viid}
            videotime ={this.getCurrentPlayerTime()}
            mode = {this.mode}

            onButton={this.endSetOffset}/>)
    
    /*
    return (
        <div className="player-video-full" id="videoplayerFullDiv">
        <video controls width="100%" muted playsinline>
          <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
        </video>      
        </div>
    )
    */


    return (
      <>
      {offsetdialog}
      
      

      <div className="player-video-full" id="videoplayerFullDiv">
          <div className="player-video">
          
              <canvas id="canvasPlayer" className="player-layer-video" ref={this.canvasLevel1Ref} />
              <canvas className="player-layer-1" ref={this.canvasLevel2Ref} />
              <canvas className="player-layer-2" ref={this.canvasLevel3Ref} />
              {extra}
          
              <div className="react-player">


                  <ReactPlayer
                  
                      ref={this.playerRef}  // Référence au ReactPlayer
                      width={20}
                      url={videofile}
                      
                      config={{
                          file: {
                            attributes: {
                              crossOrigin: "anonymous",
                            },
                          },
                        }}                      
                      
                      playing={this.state.play}  // Démarrer en pause
                      controls={false}
                      onReady={this.handleReady}  // Assigner l'événement onReady
                      onPlay={this.handlePlay}  // Gérer la lecture
                      onPause={this.handlePause}  // Gérer la pause
                  />
                </div>
                
                  
            </div>
            
            <div className="player-button-full" style={{color:"white"}}>
            
                <Button disable={!this.state.isReady} image={this.state.isPlaying?stopbutton:playbutton} onClick={this.play} width={this.buttonheight} height={this.buttonheight}/>
                <Button disable={!this.state.isReady} image={prevbutton} width={this.buttonheight} height={this.buttonheight} onClick={this.previous}/>
                <Button disable={!this.state.isReady} image={nextbutton} width={this.buttonheight} height={this.buttonheight} onClick={this.next}/>
                {extrabuttons}
                <input disabled = {!this.state.isReady} 
                type="range" min="0" max="100" id="playerslider" 
                className="sliderVideo" style={{background:"inherit"}} 
                onInput={this.handleSliderVideo} 
                onChange={this.handleSliderVideo} 
                value={this.state.videoPosition} 
                ref={this.sliderVideoRef}/>



                &nbsp;

                <Button disable={!this.state.isReady} image={this.state.mute?mutebuttonon:mutebuttonoff} onClick={this.mute} width={this.buttonheight} height={20}/>

                <input 
                type="range" min="0" max="100"
                className="sliderVideo" 
                style = {{background:"inherit", width:"25px"}}
                onInput={this.handleSliderVolume} 
                onChange={this.handleSliderVolume} 
                value={this.state.videoVolume} 
                ref={this.sliderVolumeRef}/>


                <Button disable={!this.state.isReady} image={this.state.channel===1?channel1onbutton:channel1button} 
                  width={this.buttonheight} height={this.buttonheight} onClick={this.channel1}/>
                <Button disable={!channel2enable} image={this.state.channel===2?channel2onbutton:channel2button} 
                  width={this.buttonheight} height={this.buttonheight} onClick={this.channel2}/>
                <Button disable={!this.state.isReady} image={setoffsetbutton} 
                  width={this.buttonheight} height={this.buttonheight} onClick={this.setoffset}/>

            </div>
      </div>

    </>
    );
  }
}


VideoPlayer.defaultProps = 
{
    params: {dontscale: true, displaytc:true, displaytcms: false},
    src: null,
    video: null,

}

export default VideoPlayer;
